import React, {useMemo, useState} from 'react';
import {SubmissionApi, SubmissionAuditSupervisorResult, SubmissionDto} from '../../scaffold';
import {Alert, Button, Descriptions, Divider, InputNumber, Popconfirm, Radio, Space} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import {useInput} from 'react-hanger';
import Title from 'antd/lib/typography/Title';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import SubmissionPapers from './Papers';
import Text from 'antd/es/typography/Text';

export default function SubmissionJudgeAudit(props: {submission: SubmissionDto; onSuccess: () => any}) {
  const remark = useInput('');
  const advice = useInput('');
  const auditState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionAuditJudgerPost);
  const abandonState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionAbandonJudgerPost);
  const [score01, setScore01] = useState(70);
  const [score02, setScore02] = useState(70);
  const [score03, setScore03] = useState(70);
  const [score04, setScore04] = useState(70);
  const [score05, setScore05] = useState(70);
  const secondTime = !!props.submission.logs?.find(i => i.title === '盲审审批');
  const score = score01 * 0.1 + score02 * 0.1 + score03 * 0.3 + score04 * 0.4 + score05 * 0.1;

  const des = useMemo(() => {
    if (score >= 66) return '审核通过';
    if (secondTime) return '不能参加此次答辩';
    if (score >= 60) return '申请者可在修改后第二次提交论文送达盲审，第二次合格后可申请答辩，不合格将不能参加此次答辩。';
    return '不能参加此次答辩';
  }, [score, secondTime]);

  function audit() {
    auditState
      .request({
        submissionAuditJudgerModel: {
          id: props.submission.id || 0,
          score01,
          score02,
          score03,
          score04,
          score05,
          remark: remark.value,
          advice: advice.value,
        },
      })
      .then(props.onSuccess)
      .catch(CommonApiErrorHandler);
  }
  function abandon() {
    abandonState
      .request({
        findParams: {
          id: props.submission.id || 0,
        },
      })
      .then(props.onSuccess)
      .catch(CommonApiErrorHandler);
  }
  return (
    <div>
      <Alert type={'warning'} className={'m-b-15'} message={`本次为第 ${props.submission.judgeSubmitCount} 次提交`} />
      <Title level={3}>专业盲审审核</Title>
      <SubmissionPapers submission={props.submission} isJudgeVersion={true} refresh={props.onSuccess} readonly />
      <Title className={'m-t-20'} level={4}>
        总体评价
      </Title>
      <TextArea {...remark.eventBind} placeholder={'请输入总体评价'} rows={3} />
      <Title className={'m-t-20'} level={4}>
        修改意见
      </Title>
      <TextArea {...advice.eventBind} placeholder={'请输入修改意见'} rows={3} />
      <Title className={'m-t-20'} level={4}>
        结论
      </Title>
      <Descriptions bordered column={1}>
        <Descriptions.Item label={'1.选题与综述 (10%)'}>
          <div>选题来源于实际，能解决实际问题，体现专业类别特点 文献资料的丰富度、新颖性，归纳总结的条理性。</div>
          <Space className={'m-t-5'}>
            <Text strong>请输入分数</Text>
            <InputNumber min={0} max={100} value={score01} onChange={setScore01 as any} />
            <Text strong>分</Text>
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={'2.基础知识 (10%)'}>
          <div>掌握基础知识的宽广性、系统性 运用基础理论、专业知识的正确性、灵活性。</div>
          <Space className={'m-t-5'}>
            <Text strong>请输入分数</Text>
            <InputNumber min={0} max={100} value={score02} onChange={setScore02 as any} />
            <Text strong>分</Text>
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={'3.方法与能力 (30%)'}>
          <div>研究方法或设计方案恰当，研究步骤和过程科学规范。研究内容的难度及工作量 综合分析问题、解决问题和调查研究的能力。</div>
          <Space className={'m-t-5'}>
            <Text strong>请输入分数</Text>
            <InputNumber min={0} max={100} value={score03} onChange={setScore03 as any} />
            <Text strong>分</Text>
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={'4.实践与应用 (40%)'}>
          <div>论文的应用价值、职业或行业背景、经济或社会效益。研究成果、对策或建议的指导作用、借鉴意义。</div>
          <Space className={'m-t-5'}>
            <Text strong>请输入分数</Text>
            <InputNumber min={0} max={100} value={score04} onChange={setScore04 as any} />
            <Text strong>分</Text>
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={'5.写作质量 (10%)'}>
          <div>结构合理，逻辑性强，表达准确，写作规范。引文规范，学风严谨。</div>
          <Space className={'m-t-5'}>
            <Text strong>请输入分数</Text>
            <InputNumber min={0} max={100} value={score05} onChange={setScore05 as any} />
            <Text strong>分</Text>
          </Space>
        </Descriptions.Item>
      </Descriptions>
      <Alert type={'error'} className={'m-t-15'} message={'达到 66 分为及格'} />
      <div className={'m-t-15 m-b-15'}>
        当前总分{score}分, {des}
      </div>

      <Space>
        <Popconfirm title={'确认完成审批吗'} onConfirm={audit}>
          <Button type={'primary'} loading={auditState.loading}>
            完成审批
          </Button>
        </Popconfirm>
        <Popconfirm title={'确认请求更换盲审吗'} onConfirm={abandon}>
          <Button loading={abandonState.loading}>放弃本次审核，请求更换盲审</Button>
        </Popconfirm>
      </Space>
      <Divider />
    </div>
  );
}
